import React, { FC, useEffect, useMemo, useState } from "react";
import {
  Button,
  Box,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";

import "./style.css";
import { InputSelectSimple } from "src/framework/components/forms/inputs/InputSelectSimple";
import adminStore from "src/store/AdminStore";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { ConteudoModalCorrenteReversa } from "src/components/projetos/ModalCorrenteReversa/ConteudoModalCorrenteReversa";
import { atributos$, CacheType, resolveProtocolUrl } from "src/store/global.store";
import { useObservable } from "src/framework/store/storeUtil";
import { IAtributosDom } from "../types";

export interface ModalMpptModel {
    open: boolean;
    setOpenModal: Function;
    componentId?: number;
}

const ModalMppt: FC<ModalMpptModel> = (modalDetalhesModel) => {
  const [modulosState, setModulosState] = useState([]);
  const [mpptState, setMpptState] = useState<any>();
  const [modulosInversoresState, setModulosInversoresState] = useState<any>();
  const [selectModuloState, setSelectedModulo] = useState<any>();
  const [imageEstate, setImageEstate] = useState<any>();
  const [correnteReversa, setCorrenteReversa] = useState<boolean>(false);
  const _upload = LocalStorage.get("solar.uploadInfo", true);
  const cachedAtributos = useObservable<CacheType<IAtributosDom[]>>(atributos$)
  const atributosState = useMemo(()=>{
      return cachedAtributos?.data || []
    },[cachedAtributos])

  const formatValue = (value: any, kind?: string) => {
    if (value) {
        const list = String(value)?.split(',') || [];
        const atributo = atributosState?.find((a: { id: any; }) => a?.id === kind);
        const enums = atributo?.valores?.enum;
        if (enums && list?.length) {
            return list?.map((i: any) => enums?.find((item: any) => Number(item?.value) === Number(i))?.text || '')?.join(', ');
        }
    }
    return !isNaN(Number(value))  ? String(Number(value).toFixed(2))?.replaceAll('.', ',') : value;
};

const atributos = useMemo(() =>  mpptState?.atributos, [mpptState]);

const getTitulo = (atributo: string) => {
    let objAtributo = atributosState?.find((a: { id: any; }) => a?.id === atributo)
    let descricao = objAtributo?.titulo
    if (objAtributo?.sufixo){
        descricao = `${objAtributo?.titulo} (${objAtributo?.sufixo})`
    }
    return descricao;
}

const getValor = (key: string) => {
    let objAtributo = selectModuloState?.atributos?.find((a: { atributo: any; }) => a?.atributo === key)
    return objAtributo?.valor;
}
const calcQtdeMinModulosString = getValor('MODULO_TENSAO_VMP') && atributos > 0 ? Math.ceil(atributos['INVERSOR_TENSAO_INICIALIZACAO'] / getValor('MODULO_TENSAO_VMP') || 0) : '';

const somaModuloString = (numero: number) => {
    const strings = modulosInversoresState?.filter((a: any) => a?.numero_mppt === numero)
    const soma = strings?.reduce((acumulador: number, obj: any) => {
        return acumulador + (obj.quantidade === -1 ? obj.quantidade_calculada : obj.quantidade)
      }, 0);
    return soma;
}

const somaQuantModulo = () => {
    let soma = modulosInversoresState?.reduce((acumulador: number, obj: any) => {
        return acumulador + (obj.quantidade === -1 ? obj.quantidade_calculada : obj.quantidade);
      }, 0);
    return soma;
}

const mpptOrder = mpptState?.mppt?.sort((a: { numero: number; }, b: { numero: number; }) => (a.numero > b.numero) ? 1 : -1)

const stringDinamicas = (numero: number) => {
    const strings = modulosInversoresState?.filter((a: any) => a?.numero_mppt === numero).sort((a: any, b: any) => a.numero_string - b.numero_string)
    return strings?.map(function(item: any){
        return (
            <Grid size={12}>
                <Box component="span" className='labels-mppt'>Quantidade de módulos por string {item?.numero_string} : </Box>
                <Box component="span" className="itens-mppt">{item?.quantidade === -1 ? item.quantidade_calculada : item.quantidade}</Box>
            </Grid>
        )
    })
}
var mpptDinamicos = mpptOrder?.map(function(item: any){
    return <Grid container className="grid-detalhes" size={12}>
            <Grid className="grid-texto box-atencao" size={12}>
                <Box component="h2" className="titulo-mppt">MPPT {item.numero}</Box>
            </Grid>
            <Grid className="grid-texto box-atencao" size={{ xs: 12, md: 6 }}>
                <Grid size={12}>
                    <Box component="span" className='labels-mppt'>Corrente máxima CC: </Box> 
                    <Box component="span" className="itens-mppt">{item.corrente}</Box>
                </Grid>
                <Grid size={12}>
                    <Box component="span" className='labels-mppt'>{getTitulo('INVERSOR_TENSAO_MAXIMA_ENTRADA')}: </Box> 
                    <Box component="span" className="itens-mppt">{(atributos && formatValue(atributos['INVERSOR_TENSAO_MAXIMA_ENTRADA'])) || '--'}</Box>
                </Grid>
                <Grid size={12}>
                    <Box component="span" className='labels-mppt'>Quantidade de strings: </Box> 
                    <Box component="span" className="itens-mppt">{item?.quantidade}</Box>
                </Grid>
                <Grid size={12}>
                    <Box component="span" className='labels-mppt'>Qtde. mínima de módulos string: </Box> 
                    <Box component="span" className="itens-mppt">{calcQtdeMinModulosString}</Box>
                </Grid>
                <Grid size={12}>
                    <Box component="span" className='labels-mppt'>Total de módulos: </Box> 
                    <Box component="span" className="itens-mppt">{somaModuloString(item.numero)}</Box>
                </Grid>
            </Grid>
            <Grid className="grid-texto box-atencao" size={{ xs: 12, md: 6 }}>
                {stringDinamicas(item.numero)}
            </Grid>
        </Grid>
  })

  let componente_id = modalDetalhesModel?.componentId;
  useEffect(() => {

    if (componente_id) {
        setImageEstate(null); 
        setMpptState(null); 

        adminStore.getModulos(componente_id, true).then((resp) => {
            setModulosState(resp)
        })

        adminStore.getComponente(componente_id, true).then((resp) => {
            setMpptState(resp[0]);
            const upload = resp[0]?.uploads?.filter((u: any) => u?.tipo === 'image');
            if(upload){
                setImageEstate(upload[0]);
            } else {
                setImageEstate(null);
            }

            modalDetalhesModel.setOpenModal(true);
        })
    }

}, [componente_id]);

useEffect(() => {
    if (selectModuloState?.id){
        adminStore.getModulosInversores(mpptState?.id, selectModuloState.id, true).then((resp) => {
            setModulosInversoresState(resp);
            modalDetalhesModel.setOpenModal(true);
        })
    }
}, [selectModuloState])

    useEffect(() => {
        if (selectModuloState?.id && mpptState?.id){
            const projetosProvider = new ProjetosProvider()
            projetosProvider.calcularCorrenteReversa(selectModuloState?.id, {
                inversores: [mpptState?.id]
            }).then(async resp => {
                setCorrenteReversa(resp.data?.corrente_reversa);
            })
        }
    }, [selectModuloState?.id, mpptState?.id])


  const handleClose = () => {
    modalDetalhesModel.setOpenModal(false);
    setSelectedModulo(null)
  };

  const listModulos = 
    modulosState.map((s: any) => {
        return {
            text: s.nome,
            value: s.id,
        }
    })

  return (
    <>
        <div>
            {mpptState && 
            <Dialog
                open={modalDetalhesModel.open}
                onClose={handleClose}
                maxWidth='md'
            >
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid container size={12}>

                            <Grid size={3}>
                                {
                                    imageEstate &&
                                        <img style={{ width: "160px", }} alt='Componente' src={resolveProtocolUrl(`//${_upload?.data?.url}${imageEstate.url}`)} />
                                }
                            </Grid>
                            <Grid size={9}>
                                <Box>
                                    <Box component="h2" className="titulo-mppt">Detalhes do MPPT</Box>
                                    <Box component="h3">{mpptState && mpptState?.nome}</Box>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid container size={12}>
                            { atributos && (
                                <>
                                    <Grid className="grid-detalhes" size={4}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_TENSAO_MAXIMA_ENTRADA')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_TENSAO_MAXIMA_ENTRADA']) || '--'}</Box>
                                    </Grid>
                                    <Grid className="grid-detalhes" size={4}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_POTENCIA_MAXIMA_ENTRADA')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_POTENCIA_MAXIMA_ENTRADA']) || '--'}</Box>
                                    </Grid>
                                    <Grid className="grid-detalhes" size={4}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_MENOR_NIVEL_TENSAO_MPPT')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_MENOR_NIVEL_TENSAO_MPPT']) || '--'}</Box>
                                    </Grid>
                                    <Grid className="grid-detalhes" size={4}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_MAIOR_NIVEL_TENSAO_MPPT')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_MAIOR_NIVEL_TENSAO_MPPT']) || '--'}</Box>
                                    </Grid>
                                    <Grid className="grid-detalhes" size={4}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_TENSAO_INICIALIZACAO')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_TENSAO_INICIALIZACAO']) || '--'}</Box>
                                    </Grid>
                                </>
                            )}

                            <Grid className="grid-detalhes" size={12} title={listModulos.length > 0 ? 'Selecione um módulo' : 'O inversor não possui módulos relacionados'} >
                                <InputSelectSimple
                                    name="modulo"
                                    label={"Módulo"}
                                    defaultValue={""}
                                    value={String(selectModuloState?.id)}
                                    disabled={listModulos.length > 0 ? false : true}
                                    list={listModulos}
                                    onChange={(value) => {
                                        const modulo = modulosState.find(
                                            (f: any) => f.id === value
                                            
                                        );
                                        setSelectedModulo(modulo)
                                    }}
                                />
                            </Grid>
                            <Grid className="grid-detalhes" size={3}>
                                <Box className="subtitulo">{getTitulo('MODULO_POTENCIA')}: </Box><Box component="span">{formatValue(getValor('MODULO_POTENCIA')) || '--'}</Box>
                            </Grid>
                            <Grid className="grid-detalhes" size={3}>
                                <Box className="subtitulo">{getTitulo('MODULO_TENSAO_VMP')}: </Box><Box component="span">{formatValue(getValor('MODULO_TENSAO_VMP')) || '--'}</Box>
                            </Grid>
                            <Grid className="grid-detalhes" size={3}>
                                <Box className="subtitulo">{getTitulo('MODULO_CORRENTE_MAXIMA_STC')}: </Box><Box component="span">{formatValue(getValor('MODULO_CORRENTE_MAXIMA_STC')) || '--'}</Box>
                            </Grid>
                            <Grid className="grid-detalhes" size={3}>
                                <Box className="subtitulo">{getTitulo('MODULO_COENFICIENTE_TEMPERATURA_MAX_VOC')}: </Box><Box component="span">{formatValue(getValor('MODULO_COENFICIENTE_TEMPERATURA_MAX_VOC')) || '--'}</Box>
                            </Grid>
                            <Grid className="grid-detalhes" size={4}>
                                <Box className="subtitulo">Quantidade de módulos configurados: </Box><Box component="span">{formatValue(somaQuantModulo()) || '--'}</Box>
                            </Grid>

                            <Grid className="grid-detalhes" size={12}>
                                <Grid className="grid-texto box-atencao" size={12}>
                                    <Box className='titulo-mppt' component="h4">Atenção!</Box>
                                    <Box component="p">* As quantidades de módulos exibidas nesta tela são apenas uma sugestão com base nas informações acima. Essas quantidades poderão variar de acordo com o local de instalação.</Box>
                                    <Box component="p">* As string que pertencem ao mesmo MPPT, devem ter a mesma quantidade de módulos fotovoltaicos conectados em série. </Box>
                                    <Box component="p">* Além disso, os módulos deverão ser instalados na mesma orientação e sentido.</Box>
                                </Grid>
                            </Grid>
                            { selectModuloState && !correnteReversa &&
                                mpptDinamicos
                            }
                            { selectModuloState && correnteReversa &&
                                <Grid className="grid-detalhes" size={12}>
                                    <Grid className="grid-texto box-atencao" size={12}>
                                        <ConteudoModalCorrenteReversa />
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button className='btn-modal' onClick={handleClose} >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>}
        </div>
    </>
  );
};

export { ModalMppt };
